import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { PaymentMethodsCard } from '../components/PaymentMethodsCard';
import { GenericErrorState } from '../components/GenericErrorState';
import { trackPageView } from '../utils/usageTracker';
import { usePaymentMethodsData } from '../hooks/usePaymentMethodsData';
import { jsx as _jsx } from "react/jsx-runtime";
export const PaymentMethodsPage = () => {
  const {
    loading,
    error,
    data: paymentMethods
  } = usePaymentMethodsData();
  useEffect(() => {
    trackPageView('payment-methods-overview');
  }, []);
  if (error) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "PAYMENT_METHODS_OVERVIEW_LOAD",
      children: /*#__PURE__*/_jsx(MainContentLayout, {
        children: /*#__PURE__*/_jsx(GenericErrorState, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PAYMENT_METHODS_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsx(MainContentLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "paymentMethods.title"
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "700",
        children: /*#__PURE__*/_jsx(PaymentMethodsCard, {
          paymentMethods: paymentMethods,
          loading: loading
        })
      })
    })
  });
};